import { Image } from 'expo-image'
import React from 'react'
import { StyleSheet, View } from 'react-native'

import { BORDER_RADIUS, COLOR, SPACE } from '@ui-kit/constants'

import type { NativeProps } from './types'

/**
 * @deprecated This component is deprecated and will be removed when usage is 0%.
 * Please use View from react-native with Tailwind styles.
 */
const Box = (props: NativeProps): JSX.Element => {
  return (
    <View
      onLayout={props.onLayout}
      testID={props.id}
      style={[
        {
          height: props.height && props.height,
          width: props.width && props.width,
          minWidth: props.minWidth && props.minWidth,
          maxWidth: props.maxWidth && props.maxWidth,
          minHeight: props.minHeight && props.minHeight,
          maxHeight: props.maxHeight && props.maxHeight,
          borderRadius: props.borderRadius && BORDER_RADIUS[props.borderRadius],
          padding: props.padding && SPACE[props.padding],
          paddingTop: props.paddingTop && SPACE[props.paddingTop],
          paddingBottom: props.paddingBottom && SPACE[props.paddingBottom],
          paddingVertical: props.paddingY && SPACE[props.paddingY],
          paddingLeft: props.paddingLeft && SPACE[props.paddingLeft],
          paddingRight: props.paddingRight && SPACE[props.paddingRight],
          paddingHorizontal: props.paddingX && SPACE[props.paddingX],
          margin: props.margin && SPACE[props.margin],
          marginTop: props.marginTop && SPACE[props.marginTop],
          marginBottom: props.marginBottom && SPACE[props.marginBottom],
          marginVertical: props.marginY && SPACE[props.marginY],
          marginLeft: props.marginLeft && SPACE[props.marginLeft],
          marginRight: props.marginRight && SPACE[props.marginRight],
          marginHorizontal: props.marginX && SPACE[props.marginX],
          flex: props.flex,
          flexDirection: props.direction,
          flexWrap: props.flexWrap,
          flexShrink: props.flexShrink,
          flexGrow: props.flexGrow,
          alignItems: props.alignItems,
          alignSelf: props.alignSelf,
          justifyContent: props.justifyContent,
          zIndex: props.zIndex,
          backgroundColor: props.bgColor && COLOR[props.bgColor],
          position: props.position && props.position,
          top: props.top && SPACE[props.top],
          left: props.left && SPACE[props.left],
          right: props.right && SPACE[props.right],
          bottom: props.bottom && SPACE[props.bottom],
        },
        props.style,
      ]}
    >
      {props.bgImage ? (
        <Image
          source={props.bgImage}
          style={[StyleSheet.absoluteFill, { width: props.width, height: props.height }]}
        />
      ) : null}
      {props.children}
    </View>
  )
}

export default Box
